var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconsRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.192,
    height: 13.752,
    viewBox: "0 0 8.192 13.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.18-7.385a.516.516,0,0,1,0-.73l6.308-6.359a.516.516,0,0,1,.73,0l.851.851a.516.516,0,0,1,0,.73L2.978-7.75,8.07-2.607a.516.516,0,0,1,0,.73l-.851.851a.516.516,0,0,1-.73,0Z",
    transform: "translate(8.221 -0.874) rotate(180)",
    fill: "#1a1100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconsRightArrow);
export default __webpack_public_path__ + "static/media/navigationIcons_RightArrow.0d6431fc.svg";
export { ForwardRef as ReactComponent };